var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.997 10.974H21C21.551 10.974 21.999 11.42 22 11.971C22.008 14.642 20.975 17.157 19.091 19.051C17.208 20.945 14.7 21.992 12.029 22H12C9.33905 22 6.83605 20.968 4.94905 19.091C3.05505 17.208 2.00805 14.7 2.00005 12.029C1.99205 9.357 3.02505 6.843 4.90905 4.949C6.79205 3.055 9.30005 2.008 11.971 2C12.766 2.012 13.576 2.092 14.352 2.278C14.888 2.408 15.219 2.948 15.089 3.485C14.96 4.021 14.417 4.351 13.883 4.223C13.262 4.073 12.603 4.01 11.977 4C9.84005 4.006 7.83305 4.844 6.32705 6.359C4.82005 7.874 3.99405 9.886 4.00005 12.023C4.00605 14.16 4.84405 16.166 6.35905 17.673C7.86905 19.174 9.87105 20 12 20H12.023C14.16 19.994 16.167 19.156 17.673 17.641C19.18 16.125 20.006 14.114 20 11.977C19.999 11.425 20.445 10.975 20.997 10.974ZM8.29305 11.2929C8.68405 10.9019 9.31605 10.9019 9.70705 11.2929L11.951 13.5369L18.248 6.3409C18.612 5.9279 19.243 5.8839 19.659 6.2479C20.074 6.6109 20.116 7.2429 19.752 7.6589L12.752 15.6589C12.57 15.8669 12.31 15.9899 12.033 15.9999H12C11.735 15.9999 11.481 15.8949 11.293 15.7069L8.29305 12.7069C7.90205 12.3159 7.90205 11.6839 8.29305 11.2929Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.988406b0e4bbf365e9081ed6fb788a85.svg";
export { ForwardRef as ReactComponent };